import { observable, action } from "mobx";

const Store = observable(
  {
    establishments: null,
    query: "",
    advancedFilter: false,
    page: 0,
    searchValues: "",
    setPage(page) {
      this.page = page;
    },
    setQuery(query) {
      this.query = query;
    },
    setSearchValues(vals) {
      this.searchValues = vals;
    },
    setCount(count) {
      this.count = count;
    },
    toggleAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },
    setEstablishments(establishments) {
      this.establishments = establishments;
    },
  },
  {
    setPage: action,
    setQuery: action,
    setCount: action,
    setSearchValues: action,
    setEstablishments: action,
  }
);

export default Store;
